// src/hooks/useFloatingEditorPanel.jsx
import { useState, useEffect } from 'react'
import {
  useFloating,
  inline,
  flip,
  shift,
  offset,
  autoUpdate,
  useDismiss,
  useRole,
  useInteractions,
} from '@floating-ui/react'

export function useFloatingEditorPanel({
  placement = 'top',
  gap = 6,
  boundary,
} = {}) {
  const [open, setOpen] = useState(false)

  const { refs, floatingStyles, context, update } = useFloating({
    open,
    onOpenChange: setOpen,
    placement,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(gap),
      inline(), // virtual-element (range) support  :contentReference[oaicite:1]{index=1}
      flip({ boundary }),
      shift({ boundary, padding: 8 }),
    ],
  })

  // basic ESC/Click-outside
  const { getFloatingProps } = useInteractions([
    useDismiss(context),
    useRole(context, { role: 'dialog' }),
  ])

  /** position panel relative to current Selection */
  const updateFromSelection = () => {
    const sel = window.getSelection()
    if (!sel?.rangeCount) return
    const range = sel.getRangeAt(0)
    if (range.collapsed) return

    refs.setReference({
      getBoundingClientRect: () => range.getBoundingClientRect(),
      getClientRects: () => range.getClientRects(),
    })
    update()
  }

  return {
    open,
    setOpen,
    refs,
    floatingStyles,
    getFloatingProps,
    updateFromSelection,
  }
}
